export default {"src":"/_next/static/media/circle-nodes-solid.7ffe8993.svg","height":24,"width":24};